import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const httpOptions ={
    loadPath: '/api/translationLanguages/translations/{{lng}}',
};

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: httpOptions,
        nsSeparator: ':',
        debug: false,
    });

export default i18n;
